import { Input } from '@web/components/ui/input';
import { cn } from '@web/lib/shadcn';
import { HTMLAttributes } from 'react';
import { usePaymentInputs } from 'react-payment-inputs';
import images, { type CardImages } from 'react-payment-inputs/images';

export function CardDetails({
  onChange,
  className,
}: HTMLAttributes<HTMLDivElement> & {
  onChange?: (card: { number?: string; exp?: string; ccv?: string }) => void;
}) {
  const {
    getCardNumberProps,
    getExpiryDateProps,
    getCVCProps,
    getCardImageProps,
  } = usePaymentInputs();

  return (
    <div className={cn('space-y-2', className)}>
      <div className="rounded-lg shadow-sm shadow-black/5">
        <div className="relative focus-within:z-10">
          <Input
            className="peer rounded-b-none pe-9 shadow-none [direction:inherit]"
            maxLength={19} // Standard credit card number length including spaces
            {...getCardNumberProps({
              onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
                if (e.target.value.length <= 19) {
                  // Additional validation
                  onChange?.({ number: e.target.value });
                }
              },
            })}
          />
          <div className="text-muted-foreground/80 pointer-events-none absolute inset-y-0 end-0 flex items-center justify-center pe-3 peer-disabled:opacity-50">
            <svg
              className="overflow-hidden rounded-sm"
              {...getCardImageProps({
                images: images as unknown as CardImages,
              })}
              width={20}
            />
          </div>
        </div>

        <div className="-mt-px flex">
          <div className="min-w-0 flex-1 focus-within:z-10">
            <Input
              className="rounded-e-none rounded-t-none shadow-none [direction:inherit]"
              {...getExpiryDateProps({
                onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
                  onChange?.({ exp: e.target.value });
                },
              })}
            />
          </div>
          <div className="-ms-px min-w-0 flex-1 focus-within:z-10">
            <Input
              className="rounded-s-none rounded-t-none shadow-none [direction:inherit]"
              {...getCVCProps({
                onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
                  onChange?.({ ccv: e.target.value });
                },
              })}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
